// Статичные данные акций
export const promotionsData = {
  ru: [
    {
      id: 1,
      slug: 'country-house-design-discount',
      title: 'Скидка 20% на проектирование загородного дома',
      shortDescription: 'Специальное предложение на проектирование загородного дома',
      description: `
        <h2>Скидка 20% на проектирование загородного дома</h2>
        <p>Текст описания будет добавлен позже.</p>
      `,
      bannerImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&h=600&fit=crop',
      isActive: true
    },
    {
      id: 2,
      slug: 'developer-lots-discount',
      title: 'Лоты с 20% скидкой от Застройщика',
      shortDescription: 'Эксклюзивные лоты со скидкой от застройщика',
      description: `
        <h2>Лоты с 20% скидкой от Застройщика</h2>
        <p>Текст описания будет добавлен позже.</p>
      `,
      bannerImage: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
      isActive: true
    }
  ],
  en: [
    {
      id: 1,
      slug: 'country-house-design-discount',
      title: '20% Discount on Country House Design',
      shortDescription: 'Special offer for country house design',
      description: `
        <h2>20% Discount on Country House Design</h2>
        <p>Description text will be added later.</p>
      `,
      bannerImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&h=600&fit=crop',
      isActive: true
    },
    {
      id: 2,
      slug: 'developer-lots-discount',
      title: 'Lots with 20% Discount from Developer',
      shortDescription: 'Exclusive lots with discount from developer',
      description: `
        <h2>Lots with 20% Discount from Developer</h2>
        <p>Description text will be added later.</p>
      `,
      bannerImage: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
      isActive: true
    }
  ],
  zh: [
    {
      id: 1,
      slug: 'country-house-design-discount',
      title: '乡村别墅设计享20%折扣',
      shortDescription: '乡村别墅设计特别优惠',
      description: `
        <h2>乡村别墅设计享20%折扣</h2>
        <p>详细说明稍后添加。</p>
      `,
      bannerImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&h=600&fit=crop',
      isActive: true
    },
    {
      id: 2,
      slug: 'developer-lots-discount',
      title: '开发商提供20%折扣地块',
      shortDescription: '开发商独家折扣地块',
      description: `
        <h2>开发商提供20%折扣地块</h2>
        <p>详细说明稍后添加。</p>
      `,
      bannerImage: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
      isActive: true
    }
  ]
};

export const getPromotions = (lang = 'ru') => {
  const promotions = promotionsData[lang] || promotionsData.ru;
  return promotions.filter(p => p.isActive);
};

export const getPromotionBySlug = (slug, lang = 'ru') => {
  const promotions = promotionsData[lang] || promotionsData.ru;
  return promotions.find(p => p.slug === slug);
};
